import { render, staticRenderFns } from "./SetBlock.vue?vue&type=template&id=c13d8c12&scoped=true"
import script from "./SetBlock.vue?vue&type=script&lang=js"
export * from "./SetBlock.vue?vue&type=script&lang=js"
import style0 from "./SetBlock.vue?vue&type=style&index=0&id=c13d8c12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c13d8c12",
  null
  
)

export default component.exports